import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';

@Component({
  selector: 'app-submit-checklist-sign-modal',
  templateUrl: './submit-checklist-sign-modal.component.html',
  styleUrls: ['./submit-checklist-sign-modal.component.css']
})
export class SubmitChecklistSignModalComponent implements OnInit {

  @ViewChild('signaturePad', { static: false }) signaturePad;
  @Input() signed: any;
  @Input() type: string;
  @Input() where: string;
  @Input() enableCheckboxSign: boolean;
  typeSign: boolean = false;
  redBorder: boolean = false;
  submitSignImg: any;
  hideClick: boolean = false;
  showClickMsg: boolean = false;
  rawImgData: any;

  signaturePadOptions: Object = {
    'canvasWidth': 410,
    'canvasHeight': 150
  }

  constructor(private activeModal: NgbActiveModal, private employeeService: EmployeeService) { }

  ngOnInit(): void {
    this.signed = this.signed != null;
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }

  submitClicked() {
    if (this.signed)
      this.activeModal.close("signed");
    else {
      if (this.typeSign || !this.signaturePad.isEmpty()) {
        this.activeModal.close({ data: this.typeSign ? this.rawImgData : this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, ""), typeSign: this.typeSign });
      } else {
        this.redBorder = true;
      }
    }
  }

  getTypeSign(type: string) {
    if (this.signaturePad.isEmpty()) {
      this.typeSign = true;
      if (this.typeSign) {
        this.employeeService.getTypeSign(type).then((response: any) => {
          this.rawImgData = response;
          this.submitSignImg = "data:image/png;base64," + response;
        });
      }
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  clear() {
    this.typeSign = false;
    if (this.signaturePad != null)
      this.signaturePad.clear();
    this.showClickMsg = false;
    this.hideClick = false;
  }
}
